import { useState, FC} from 'react';
import FormItem from './FormItem';
import Input from "shared/Input/Input";
import {
    TrashIcon
} from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';

export interface AdditionalDateFieldProps {
    key: number;
    onChange: (index: number, value: any) => void;
    onDelete: (index: number) => void;
}

const AdditionalDateField: FC<AdditionalDateFieldProps> = ({ key, onChange, onDelete }) => {

    const { t, ready } = useTranslation("translation");

    const [dateString, setDateString] = useState("dd/mm/yyyy");

    if (!ready) {
        return null;
    }

    const handleOnChange = (field:string, value:any) => {
        const date = new Date(value);
        setDateString(date.toISOString());
        onChange(key, date.toISOString());
    }

    return (
        <div className="w-full align-center items-center justify-between" key={key}>
            <FormItem
                label={`${t("translation:components.holidayPackageForm.page2.form.fixedDateLabel")}`}
                desc={t("translation:components.holidayPackageForm.page2.form.fixedDateDescription")}
            >
                <div className="flex flex-row w-full align-center items-center justify-between">
                    <Input
                        type="date"
                        defaultValue={dateString}
                        onChange={(e) => handleOnChange(`fixed_dates_start`, e.target.value)}
                        placeholder={t("translation:components.holidayPackageForm.page2.form.startDateName")}
                    />
                    <div
                        id={`${key}`}
                        aria-label="Delete date field"
                        role="button"
                        className="text-red-500 hover:text-red-700 ml-2"
                        onClick={(e) => onDelete(parseInt(e.currentTarget.id))}
                    >
                        <TrashIcon className="w-5 h-5" />
                    </div>
                </div>
            </FormItem>
        </div>
    )
}

export default AdditionalDateField;